
import axios from 'axios'
import { url } from './url'


function getShippings(query) {
    var urlString = `${url}/shipping`;
    return axios
        .get(urlString,{params:query})
        .then(res => {
            return {
                total: res.data.total,
                shippings: res.data.shippings.map(shipping => {
                    return {
                        _id: shipping._id,
                        shippingName:shipping.name,
                        hardwares: shipping.hardwares,
                        totalHardwares:shipping.hardwares.length,
                        customer: shipping.customer,
                        type: shipping.type,
                        createdAt: shipping.createdAt,
                        status: shipping.status,
                        image: shipping.image,
                        isDemo:shipping.isDemo
                    };
                })
            }
        });
}

function createShipping(shipping) {
    return axios.post(`${url}/shipping`, shipping)
        .then(resp => {
            return resp.data
        })
}
function sendMailShippings(shipping) {
    return axios.post(`${url}/shipping/send_mail`, shipping)
        .then(resp => {
            return resp.data
        })
}
function updateShipping(shipping) {
    return axios.put(`${url}/shipping/${shipping._id}`, shipping)
        .then(resp => {
            return resp.data
        })
}
export default {
    getShippings,
    createShipping,
    updateShipping,
    sendMailShippings
};